import React from 'react';
import clsx from 'clsx';
import DeleteComponentPopUpWindow from '../PopUpsValidations/DeleteComponentPopUpWindow';

const DeletePageButton = (props) => {

    const{
        editor,
        selectedPage,
        deletePageClicked
    } = props;

    const [openDeletePage, setOpenDeletePage] = React.useState(false);


    const deletePage = () => {
        if(editor.Commands.isActive('view-annotations') === false){
          setOpenDeletePage(true);
        }
    };

    const handleClose = () => {
        setOpenDeletePage(false);
    };
    
    const confirmDeletePage = () => {
        handleClose();
        deletePageClicked();
    };

    return(
        <>
            <div
              id='deletePageButton'
              data-tooltip="Delete page"
              data-tooltip-pos="bottom"
              className={clsx('fa', 'fa-trash', 'fa-trash2', 'gjs-pn-btn', 'gjs-pn-btn4')}
              onClick={deletePage}
              style={selectedPage < 0 ? { display: 'none' } : null}
              aria-hidden="true"
            >
              {' '}
            </div>
            <DeleteComponentPopUpWindow
                handleClose={handleClose}
                confirmDeleteComponent={confirmDeletePage}
                component="page"
                open={openDeletePage}
                setOpen={setOpenDeletePage}
            />
        </>
    )

}

export default DeletePageButton;